module.exports = __webpack_public_path__ + "img/jumpButton.9d2fc93b.png";